export default "__VITE_ASSET__20a11659__"